import { Suspense } from "react"

import ContentSection from "./views/ContentSection/ContentSection"
import Header from "./views/header/Header"
import TopHeader from "./views/topHeader/TopHeader"
import Contact from "./views/Contact/Contact"
import Form from "./Form"
import GyroActivatorIOS from "./tools/GyroActivatorIOS"



export default function Experience() {

    return <>
        
        <Suspense fallback={null}>
            <div className="top-container">
                <TopHeader />
                <Header />
                <div className="scroll-container">
                    <p className="karrik">DÉFILEZ VERS LE BAS</p>
                    <div className="arrow-container">
                        <img src="/img/arrow.svg" alt="" />
                        <img src="/img/arrow.svg" alt="" />
                        <img src="/img/arrow.svg" alt="" />
                    </div>
                    <p className="karrik">DÉFILEZ VERS LE BAS</p>
                    <div className="arrow-container">
                        <img src="/img/arrow.svg" alt="" />
                        <img src="/img/arrow.svg" alt="" />
                        <img src="/img/arrow.svg" alt="" />
                    </div>
                    <p className="karrik">DÉFILEZ VERS LE BAS</p>
                </div>
            </div>
            <ContentSection />
            <Contact />
        </Suspense >
        <Form />
    </>
}